// src/views/Business/BusinessDrivers.js
import React,{useEffect,useState} from 'react';
import {db} from '../../firebase/firebase.js';
import {collection,onSnapshot,query,orderBy} from 'firebase/firestore';
import {useAuth} from '../../auth/AuthContext.js';

export default function BusinessDrivers(){
  const {user}=useAuth();

  // Business ID always comes from the user profile
  const businessId=user?.businessId;

  const[drivers,setDrivers]=useState([]);
  const[loading,setLoading]=useState(true);

  useEffect(()=>{
    if(!businessId)return;

    const q=query(
      collection(db,'businesses',businessId,'drivers'),
      orderBy('createdAt','desc')
    );

    const unsub=onSnapshot(q,(snap)=>{
      const arr=[];
      snap.forEach(d=> arr.push({...d.data(),id:d.id}));
      setDrivers(arr);
      setLoading(false);
    });

    return()=>unsub();
  },[businessId]);

  if(loading){
    return(
      <div className="min-h-screen flex justify-center items-center bg-neutral-950 text-white">
        <p className="opacity-60 text-lg">Loading drivers...</p>
      </div>
    );
  }

  return(
    <div className="min-h-screen bg-neutral-950 text-white px-6 py-10">
      <div className="max-w-6xl mx-auto">

        {/* Page Header */}
        <h2 className="text-3xl font-semibold mb-8">Business Drivers</h2>

        {/* Driver Table */}
        <div className="bg-neutral-900 rounded-2xl shadow-lg p-6 overflow-x-auto">
          <table className="w-full text-left border-collapse min-w-[800px]">
            <thead>
              <tr className="text-neutral-400 text-sm uppercase tracking-wide border-b border-neutral-800">
                <th className="py-3">Name</th>
                <th className="py-3">Phone</th>
                <th className="py-3">Email</th>
                <th className="py-3">Vehicle</th>
                <th className="py-3">Status</th>
                <th className="py-3">Joined</th>
              </tr>
            </thead>

            <tbody>

              {/* No Drivers */}
              {drivers.length===0&&(
                <tr>
                  <td colSpan="6" className="text-center py-6 opacity-60">
                    No drivers registered yet.
                  </td>
                </tr>
              )}

              {/* Driver Rows */}
              {drivers.map((d)=>(
                <tr 
                  key={d.id}
                  className="border-b border-neutral-800 hover:bg-neutral-800/40 transition"
                >
                  <td className="py-3">{d.name||"-"}</td>
                  <td className="py-3">{d.phone||"-"}</td>
                  <td className="py-3">{d.email||"-"}</td>
                  <td className="py-3">{d.vehicle||d.vehicleType||"-"}</td>

                  <td className="py-3">
                    <span className={`px-3 py-1 rounded-lg text-sm ${
                      d.active
                        ? 'bg-green-600/20 text-green-400'
                        : 'bg-neutral-700 text-neutral-300'
                    }`}>
                      {d.active ? "Active" : "Inactive"}
                    </span>
                  </td>

                  <td className="py-3">
                    {d.createdAt
                      ? new Date(d.createdAt).toLocaleDateString()
                      : "-"
                    }
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
